import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EcosenseLogo from "../../../assets/img/report_logo.png";

/**
 * Shared header component for all PDF report pages.
 * Left: Company logo (from reportDetails.logoUrl)
 * Right: "Radon Data Analysis By:" + ecosense logo
 */
const ReportPageHeader = ({ reportDetails }) => {
    const companyLogoUrl = reportDetails?.company_logo_url;

    return (
        <div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20 }}>
            <Grid container alignItems="center" style={{ width: "100%" }}>
                {/* Left: Company logo */}
                <Grid item xs={6}>
                    {companyLogoUrl ? (
                        <img
                            src={companyLogoUrl}
                            alt="Company Logo"
                            style={{
                                height: 50,
                                width: "auto",
                                maxWidth: "100%",
                                display: "block",
                                marginRight: "auto",
                            }}
                        />
                    ) : (
                        <div style={{ height: 55 }} />
                    )}
                </Grid>

                {/* Right: Radon Data Analysis By + ecosense logo */}
                <Grid item xs={6} style={{ textAlign: "right" }}>
                    <Typography
                        style={{
                            color: "#000",
                            fontSize: "10px",
                            fontStyle: "italic",
                            marginBottom: 4,
                        }}
                    >
                        Radon Data Analysis By:
                    </Typography>
                    <img
                        src={EcosenseLogo}
                        alt="ecosense"
                        style={{ height: 33, objectFit: "contain" }}
                    />
                </Grid>
            </Grid>

            <div
                style={{
                    marginTop: 0,
                    height: "4px",
                    background: "#575195",
                    borderRadius: 1,
                }}
            />
        </div>
    );
};

export default ReportPageHeader;
